import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from './LoadingSpinner';

const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { user, loading, isAuthenticated } = useAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if user has required role
  if (requiredRoles.length > 0 && !requiredRoles.includes(user?.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl text-gray-400 mb-4">🚫</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h1>
          <p className="text-gray-600 mb-4">
            You don't have permission to access this page.
          </p>
          <p className="text-sm text-gray-500">
            Required role: {requiredRoles.join(' or ')} | Your role: {user?.role}
          </p>
        </div>
      </div>
    );
  }

  // Allow sellers to access routes even if not approved (for development/testing)
  // TODO: Re-enable approval check in production
  // if (user?.role === 'seller' && !user?.isApproved && requiredRoles.includes('seller')) {
  //   return (
  //     <div className="min-h-screen flex items-center justify-center">
  //       <div className="text-center max-w-md mx-auto">
  //         <div className="text-6xl text-yellow-400 mb-4">⏳</div>
  //         <h1 className="text-2xl font-bold text-gray-900 mb-2">Approval Pending</h1>
  //         <p className="text-gray-600 mb-4">
  //           Your seller account is currently under review by our administrators.
  //         </p>
  //         <p className="text-sm text-gray-500">
  //           You'll receive an email notification once your account is approved.
  //           This usually takes 24-48 hours.
  //         </p>
  //       </div>
  //     </div>
  //   );
  // }

  return children;
};

export default ProtectedRoute;
